import { Card, Group, Text } from "@mantine/core";
import { IconBuilding } from "@tabler/icons-react";

import OverviewFilterCaption from "../common/OverviewFilterCaption";
import OverviewStat from "../common/OverviewStat";

interface AccountOverviewCounts {
	total: number;
	active: number;
}

interface AccountOverviewProps extends AccountOverviewCounts {
	// Counts under the page's filters, shown under each total; null unfiltered
	filtered?: AccountOverviewCounts | null;
	filterLabel?: string | null;
}

function AccountOverview({ total, active, filtered, filterLabel }: AccountOverviewProps) {
	return (
		<Card
			shadow="sm"
			padding="lg"
			radius="md"
			withBorder
			mb="lg">
			<Group
				justify="space-between"
				mb="md">
				<Group>
					<IconBuilding size={20} />
					<Text fw={500}>Account Overview</Text>
				</Group>
				<OverviewFilterCaption label={filtered ? (filterLabel ?? null) : null} />
			</Group>
			<Group>
				<OverviewStat
					value={total}
					label="Total Accounts"
					filteredValue={filtered?.total}
				/>
				<OverviewStat
					value={active}
					label="Active Accounts"
					color="green"
					filteredValue={filtered?.active}
				/>
			</Group>
		</Card>
	);
}

export default AccountOverview;
